import React from "react"
import { Card, CardBody, Col } from "reactstrap"
import { useTranslation } from "react-i18next"

const OrderItemCard = ({ item }: { item: any }) => {
  const { t } = useTranslation()
  return (
    <Col xxl="3" xl="4" sm="6">
      <Card className="shadow-md">
        <CardBody className="p-1">
          <div className="d-flex ">
            <div className="p-2">
              <img src={item.image} alt="" />
            </div>
            <div className="p-2 w-100 d-flex flex-column justify-content-between">
              <div>
                <p className="mb-0">
                  <span className="font-size-16 text-semi-dark fw-semibold ">
                    {item.name}
                  </span>
                </p>

                <p className="mb-0">
                  <span className="text-muted text-12px">{item.category}</span>
                  <span className="text-muted text-12px">{item.brand}</span>
                  <span className="text-muted text-12px">
                    <i className="bx bxs-star pl-1"></i>
                    {item.rate}
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-center w-100  fw-bold text-semi-dark">
                <p className="mb-0">
                  <span className="text-12px">{t("orders_qty")}</span>
                  <span className="text-14 mx-2">{item.quantity}</span>
                </p>
                <p className="mb-0">
                  <span className="text-12px">{t("common_price")}</span>
                  <span className="text-14 mx-2">{item.price}</span>
                </p>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default OrderItemCard
